import {
  eighteenYearsFromCurrentDate,
  eightyFiveYearsFromCurrentDate,
  fortyOneYearsFromCurrentDate,
  ninetyOneDays,
  sixtyFiveYearsFromCurrentDate,
  twentyFiveYearsFromCurrentDate,
  twoHundredYearsFromCurrentDate,
} from "Constants/general";
import { analytics } from "firebase.config";
import { logEvent } from "firebase/analytics";
import {
  DiseasesTypes,
  getPincodesResponse,
  MemberData,
  MemberTypes,
  Salutation,
} from "Interfaces/general";
import { Lifestyle } from "Pages/Lifestyle";
import { KeyboardEvent } from "react";
import { MdBackHand } from "react-icons/md";
import { formatPhoneNumberIntl } from "react-phone-number-input";

export const logFirebaseEvents = (eventName: string, eventData: any) => {
  logEvent(analytics, eventName, { ...eventData });
  // console.log("event created", eventName, eventData);
};

export const getPhoneNumber = (phone: string) => {
  const phoneNumberArr = formatPhoneNumberIntl(phone).split(" ");

  let formatedPhone = phoneNumberArr[0];

  phoneNumberArr.shift();

  formatedPhone = formatedPhone + "-" + phoneNumberArr.join(" ");
  return formatedPhone.split(" ").join("");
};

export const mobileNumRegex = /^[6-9]{1}[0-9]{9}$/;

export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
// export const onlyAlphabetsRegex = /^[a-zA-Z]+$/


export const numberRegex = /^[0-9]*$/

export const onlyAlphabetsRegex = /^[a-zA-Z]+$/


export const IndianRupeeFormatFromString = (num: string, shouldShowDecimals = false) => {
  if (shouldShowDecimals) {
    return IndianNumberFormat(parseFloat(num).toFixed(2));
  } else {
    return IndianNumberFormat(parseFloat(num).toString());
  }
};

export const IndianNumberFormat = (number: string) => {
  let integralPart = number.includes(".") ? number.split(".")[0] : number;
  let length = integralPart.length;
  let result = "";
  let count = 1;

  for (let i = length - 1; i >= 0; i--) {
    result = integralPart[i] + result;
    if (length > count) {
      if (count === 3) {
        result = "," + result;
      }
      if (count === 5) {
        result = "," + result;
      }
      if (count === 7) {
        result = "," + result;
      }
      if (count === 9) {
        result = "," + result;
      }
    }

    count++;
  }
  if (number.includes(".")) {
    result = result + "." + number.split(".")[1];
  }
  return result;
};

export const onlyAllowTypingNumbers = (e: KeyboardEvent<HTMLInputElement>) => {
  if (!(e.key === "Backspace" || e.key === "Tab" || e.key === "ArrowDown")) {
    if (e.key.charCodeAt(0) < 47 || e.key.charCodeAt(0) > 58) {
      e.preventDefault();
    }
  }
};

export const onlyAllowTypingAlphabetNumeric = (
  e: KeyboardEvent<HTMLInputElement>
) => {
  if (
    (e.key.charCodeAt(0) > 64 && e.key.charCodeAt(0) < 91) ||
    (e.key.charCodeAt(0) > 96 && e.key.charCodeAt(0) < 123) ||
    (e.key.charCodeAt(0) > 47 && e.key.charCodeAt(0) < 58)
  ) {
    console.log("");
  } else {
    e.preventDefault();
  }
};

export const onlyAllowTypingAlphabet = (e: KeyboardEvent<HTMLInputElement>) => {
  if (
    (e.key.charCodeAt(0) > 64 && e.key.charCodeAt(0) < 91) ||
    (e.key.charCodeAt(0) > 96 && e.key.charCodeAt(0) < 123) ||
    e.key == " "
  ) {
  } else {
    e.preventDefault();
  }
};

// export const getGenderFromSalutation = (salutation: '') => {

// }

export const getFamilyComposition = (
  members: {
    type: MemberTypes;
    dob: string;
  }[]
) => {
  let noOfAdults = 0;
  let noOfChilds = 0;
  let char = "A";

  members.forEach((member) => {
    const age = getAgeFromDob(new Date(member.dob));
    if (
      member.type === "spouse" ||
      member.type === "self" ||
      member.type === "father" ||
      member.type === "father-in-law" ||
      member.type === "mother" ||
      member.type === "mother-in-law"
    ) {
      noOfAdults = noOfAdults + 1;
    } else if (member.type === "son" || member.type === "daughter") {
      noOfChilds = noOfChilds + 1;
    }
    if (
      member.type == "father" ||
      member.type === "mother" ||
      member.type === "father-in-law" ||
      member.type === "mother-in-law"
    ) {
      char = "P";
    }
  });

  let compositionText = noOfAdults + char;

  if (noOfChilds) {
    compositionText = compositionText + "+" + noOfChilds + "C";
  }
  return compositionText;
};

export const relationshipMap = {
  self: "SELF",
  spouse: "SPOUSE",
  daughter: "DAUGHTER",
  son: "SON",
  father: "FATHER",
  mother: "MOTHER",
  "mother-in-law": "MOTHER_IN_LAW",
  "father-in-law": "FATHER_IN_LAW",
};

export const genderMap = {
  male: "MALE",
  female: "FEMALE",
  unknown: "UNKNOWN",
};

export const maritalStatusMap = {
  married: "MARRIED",
  unmarried: "UNMARRIED",
  divorced: "DIVORCED",
};

export const isMemberIncludedByType = (
  members: MemberData[],
  searchedMemberType: MemberTypes
) => {
  return members.map((member) => member.type).includes(searchedMemberType);
};

export const maritalStatusfromType = (
  memberType: MemberTypes,
  spouseIncluded: boolean,
  sonIncluded: boolean,
  daughterIncluded: boolean,
  FatherInLawIncluded: boolean,
  MotherInLawIncluded: boolean
) => {
  if (memberType === "daughter" || memberType === "son") {
    return "UNMARRIED";
  } else if (
    memberType === "self" &&
    !spouseIncluded &&
    !sonIncluded &&
    !daughterIncluded &&
    !FatherInLawIncluded &&
    !MotherInLawIncluded
  ) {
    return "UNMARRIED";
  } else {
    return "MARRIED";
  }
};
export const genderFromType = (memberType: string) => {
  if (
    memberType === "daughter" ||
    memberType === "mother" ||
    memberType === "mother-in-law"
  ) {
    return "FEMALE";
  } else if (
    memberType === "son" ||
    memberType === "father" ||
    memberType === "father-in-law"
  ) {
    return "MALE";
  } else {
    return "UNKNOWN"; //TODO for spouse and self
  }
};

export const getSpouseSalutaion = (salutation: Salutation) => {
  console.log(salutation);
  if (salutation === "Mr") return "Mrs";
  if (salutation === "Mrs") return "Mr";
  if (salutation === "Mx") return "Mx";
  if (salutation === "Miss") return "Mr";

  return "Mr";
};
export const salutationFromType = (memberType: MemberTypes) => {
  if (memberType === "daughter") {
    return "Miss";
  }
  if (memberType === "mother" || memberType === "mother-in-law") {
    return "Mrs";
  } else if (
    memberType === "son" ||
    memberType === "father" ||
    memberType === "father-in-law"
  ) {
    return "Mr";
  } else {
    return "Mr";
  }
};

export const selfSpouseGenderFromSalutation = (
  memberType: "self"|"spouse",
  salutation: Salutation
) => {
  if (memberType === "self") {
    if (salutation === "Mr") {
      return "MALE";
    } else if (salutation == "Miss") {
      return "FEMALE";
    } else if (salutation == "Mrs") {
      return "FEMALE";
    } else if (salutation == "Mx") {
      return "UNKNOWN";
    }
  } else if (memberType === "spouse") {
    if (salutation === "Mr") {
      return "FEMALE";
    } else if (salutation == "Miss") {
      return "MALE";
    } else if (salutation == "Mrs") {
      return "MALE";
    } else if (salutation == "Mx") {
      return "UNKNOWN";
    }
  }
  // else {
  return "UNKNOWN";
  // }
};
export const convertDOBToYYYYMMDD = (date: string) => {

  // 23/2/2000 --> 2000-2-12
  // 23/2/2000 --> 2000-02-12
  try {
    let formattedDate = date.split('/')
    let day = parseInt(formattedDate[0])
    let month = parseInt(formattedDate[1])
  
    if (day <= 9) {
      formattedDate[0] = '0'+ day
    }
    if (month <= 9) {
      formattedDate[1] = '0'+ month
    }
  
    return formattedDate.reverse().join('-')
    
  }
  catch (error) {
    return ''
    
  }


};

export const getAgeFromDob = (dob: Date) => {
  const dobInNumber = +dob;
  const todaysDate = +new Date();
  const ageInSeconds = todaysDate - dobInNumber;
  return ageInSeconds / (24 * 3600 * 365.25 * 1000);
};

export const pincodeLabelFormatter = (pincodesArray: getPincodesResponse[]) => {
  return pincodesArray.map((pincode) => {
    return {
      ...pincode,
      value: pincode.area.toString(),
      label: `${pincode.area_name}(${pincode.pincode})`,
    };
  });
};

export const getMembersAgeLimit = (
  memberType: MemberTypes,
  isNewUser: boolean
) => {
  const ageLimit = {
    min: "",
    max: "",
  };
  // Alumni - 18 to 65 years
  // Above 65* for existing
  // Parents - 51 to 85 years
  // Above 85* or existing
  // Parents-in-law - 51 to 85 years
  // Above 85* or existing
  // Children - 91 days to 24 years

  let minAge = "";
  let maxAge = "";

  if (memberType === "son" || memberType == "daughter") {
    minAge = twentyFiveYearsFromCurrentDate;
    maxAge = ninetyOneDays;
  }

  if (isNewUser) {
    if (memberType === "mother" || memberType === "father") {
      minAge = eightyFiveYearsFromCurrentDate;
      maxAge = fortyOneYearsFromCurrentDate;
    } else if (
      memberType === "father-in-law" ||
      memberType === "mother-in-law"
    ) {
      minAge = eightyFiveYearsFromCurrentDate;
      maxAge = fortyOneYearsFromCurrentDate;
    } else if (memberType === "self" || memberType === "spouse") {
      minAge = eightyFiveYearsFromCurrentDate;
      maxAge = eighteenYearsFromCurrentDate;
    }
  } else {
    // OLD MEMBER CASE
    if (memberType === "mother" || memberType === "father") {
      minAge = twoHundredYearsFromCurrentDate;
      maxAge = fortyOneYearsFromCurrentDate;
    } else if (
      memberType === "father-in-law" ||
      memberType === "mother-in-law"
    ) {
      minAge = twoHundredYearsFromCurrentDate;
      maxAge = fortyOneYearsFromCurrentDate;
    } else if (memberType === "self" || memberType === "spouse") {
      minAge = twoHundredYearsFromCurrentDate;
      maxAge = eighteenYearsFromCurrentDate;
    }
  }

  ageLimit.min = minAge;
  ageLimit.max = maxAge;
  return ageLimit;
};

export const getAgeObjFromDob = (userinput: Date) => {
  //collect input from HTML form and convert into date format
  var dob = new Date(userinput);

  //execute if the user entered a date
  //extract the year, month, and date from user date input
  let dobYear = dob.getFullYear();
  let dobMonth = dob.getMonth();
  let dobDate = dob.getDate();

  //get the current date from the system
  let now = new Date();
  //extract the year, month, and date from current date
  let currentYear = now.getFullYear();
  let currentMonth = now.getMonth();
  let currentDate = now.getDate();

  //declare a variable to collect the age in year, month, and days
  let ageString = "";

  //get years
  let yearAge = currentYear - dobYear;

  //get months
  if (currentMonth >= dobMonth)
    //get months when current month is greater
    var monthAge = currentMonth - dobMonth;
  else {
    yearAge--;
    var monthAge = 12 + currentMonth - dobMonth;
  }

  //get days
  if (currentDate >= dobDate)
    //get days when the current date is greater
    var dateAge = currentDate - dobDate;
  else {
    monthAge--;
    var dateAge = 31 + currentDate - dobDate;

    if (monthAge < 0) {
      monthAge = 11;
      yearAge--;
    }
  }
  //group the age in a single variable
  const age = {
    years: yearAge,
    months: monthAge,
    days: dateAge,
  };

  if (age.years > 0 && age.months > 0 && age.days > 0)
    ageString =
      age.years +
      " years, " +
      age.months +
      " months, and " +
      age.days +
      " days old.";
  else if (age.years == 0 && age.months == 0 && age.days > 0)
    ageString = "Only " + age.days + " days old!";
  //when current month and date is same as birth date and month
  else if (age.years > 0 && age.months == 0 && age.days == 0)
    ageString = age.years + " years old. Happy Birthday!!";
  else if (age.years > 0 && age.months > 0 && age.days == 0)
    ageString = age.years + " years and " + age.months + " months old.";
  else if (age.years == 0 && age.months > 0 && age.days > 0)
    ageString = age.months + " months and " + age.days + " days old.";
  else if (age.years > 0 && age.months == 0 && age.days > 0)
    ageString = age.years + " years, and" + age.days + " days old.";
  else if (age.years == 0 && age.months > 0 && age.days == 0)
    ageString = age.months + " months old.";
  //when current date is same as dob(date of birth)
  else ageString = "Welcome to Earth! <br> It's first day on Earth!";

  //display the calculated age

  if (age.years) return age.years + " Years";
  if (age.months) return age.months + " Months";
  return age.days + " Days";

  return ageString;
};

export const getDiseasesList = (extra_info: {
  [key in DiseasesTypes]: string;
}) => {
  const diseasesList: {
    value: string;
    label: string;
  }[] = [];

  Object.entries(extra_info).forEach(([key, value]) => {
    if (value == "1") {
      if (chronicDiseasesMap.hasOwnProperty(key)) {
        diseasesList.push({
          label: chronicDiseasesMap[key].displayText,
          value: key,
        });
      }
    }
  });

  return diseasesList;
};

export const OldChronicDiseaseMap: {
  [key: string]: string;
} = {
  liverDisease: "Chronic Kidney Disease/ Liver Disease/ Pancreatic Disease",
  bloodPressure: "High Blood Pressure",
  bloodDisorder: "Blood or Immunity Disorder",
  immunityDisorder:
    "Disorders of Immunity (Like AIDS-HIV/ Rheumatoid Arthritis/ Ulcerative colitis)",
  endocrineDisorder:
    "Disorders of Pituitary, Adrenal, Parathyroid Glands or Growth Retardation(Endocrine System Disorder)",
  cardiovascularDisease:
    "Heart and Lung Related Issues (Cardiovascular Diseases)",
  neuromuscularDisorder: "Any Brain, Nervous System (Neuromuscular Disorders)",
  kidneyUrinaryReproductiveDisease:
    "Kidney /Urinary Tract /Reproductive Organ Disease",
  diabetesHypertensionHyperlipidaemia: "Diabetes",
  cancer: "Cancer or Any Tumour",
};

export const chronicDiseasesMap: {
  [key: string]: {
    displayText: string;
    disclaimerText: string;
  };
} = {
  neuromuscularDisorder: {
    displayText: "Any Brain, Nervous System or Neuromuscular Disorders",
    disclaimerText:
      "Brain/ nervous system: Stroke/haemorrhage/CVA, any type of paralysis of hand/legs/body(not polio), multiple sclerosis, GBS, epilepsy or seizure disorder, brain tumours, any disorder causing spontaneous or continuous body movement or failure to maintain balance (ataxia/chorea).<br/><br/> Neuromuscular disorders : Any disorder causing muscle/ nerve cell wasting/ Loss of movement.<br/><br/> Abnormal movement: Motor neurone diseases, muscular dystrophies, cerebral palsy",
  },
  cancer: {
    displayText: "Cancer or Any Tumour",
    disclaimerText:
      "All type of cancer , blood disorders (sickle cell disease, thalassemia major, haemophilia, spherocytosis, disorders of bone marrow or benign tumour of major organs( Ex. Brain, Lung, Kidney, Heart, Spleen, Pancreas, Liver )",
  },
  cardiovascularDisease: {
    displayText: "Heart and Lung Related Issues",
    disclaimerText:
      "Heart disorders: All heart disorders /cardiovascular disorders: CABG(bypass surgery), PTCA (angioplasty), CAD(coronary artery diseases), heart attack(myocardial infarction), valve diseases, heart failure, cardiomyopathy, cardiac hypertrophy, pacemaker implantation, peripheral vascular disease.<br/><br/>Lung disorders: COPD(chronic obstructive Pulmonary Disease), ILD (Interstitial Lung Disease), cystic fibrosis, emphysema, pneumoconiosis, atelectasis, sleep apnoea, chronic bronchitis .",
  },
  liverDisease: {
    displayText: "Chronic Kidney Disease, Liver Disease",
    disclaimerText:
      "Kidney disease: All type of kidney disease except congenital single kidney/kidney donation. <br/>Liver disease: All type of liver disease except grade 1 fatty liver .",
  },
  endocrineDisorder: {
    displayText:
      "Disorders of Pituitary, Adrenal, Parathyroid Glands or Growth Retardation",
    disclaimerText:
      "All disorders of pituitary, adrenal, parathyroid glands or growth retardation except hypothyroidism",
  },

  immunityDisorder: {
    displayText:
      "Disorders of Immunity (Like AIDS-HIV/ Rheumatoid Arthritis/ Ulcerative colitis)",
    disclaimerText:
      "All type of disorders of immunity (Like AIDS-HIV/Rheumatoid Arthritis/Ulcerative colitis , chon’s disease , SLE and ankylosing spondylitis )",
  },
  brainStroke: {
    displayText: "Brain Stroke",
    disclaimerText: "Stroke/ CVA /Haemorrhage",
  },
};

export const capitalizeFirstLetter = (str: string) => {
  // converting first letter to uppercase
  try {
    str = str.toLowerCase()
    const capitalized = str.replace(/^./, str[0].toUpperCase());
    return capitalized;
  } catch (e) { 
    console.log(e)
    return ""
  }

};

export const getMembersWeight = (type: MemberTypes) => {
  if (type === "self") return 1;
  if (type === "spouse") return 2;
  if (type === "son") return 3;
  if (type === "daughter") return 4;
  if (type === "father") return 5;
  if (type === "mother") return 6;
  if (type === "father-in-law") return 7;
  if (type === "mother-in-law") return 8;

  return 0;
};

export const getMemberTypeDisplayText = (memberType: string, separator?: string) => {
  separator = separator ? separator : '-';
  let displayText = "";
  displayText = memberType.includes(separator)
    ? memberType.split(separator).join(" ")
    : memberType;
  return capitalizeFirstLetter(displayText);
};

// export const ageCalculator = (dob: Date) => {
//   console.log('getAgeObjFromDob');

//   const dobInNumber = +dob;
//   console.log(dobInNumber, 'dobInNumber')
//   const todaysDate = +new Date();
//   console.log(todaysDate, 'todaysDate')
//   const ageInSeconds = todaysDate - dobInNumber;

//   console.log(ageInSeconds, 'ageInSeconds')

//   const ageInYear = Math.round(ageInSeconds / (24 * 3600 * 365.25 * 1000));

//   console.log(ageInYear, 'ageInYear')

//   const ageInMonths = new Date().getMonth() - dob.getMonth();

//   console.log(ageInMonths, 'ageInMonths')

//   const ageInDays = new Date().getDate() - dob.getDate();

//   console.log(ageInDays, 'ageInDays')

//   if (ageInYear) return ageInYear + " Years";
//   if (ageInMonths) return ageInMonths + " Months";
//   return ageInDays + " Days";
// };

// export const getAgeObjectFromDob = (dob: Date) => {
//   const dobInNumber = +dob;
//   const todaysDate = +new Date();
//   const ageInSeconds = todaysDate - dobInNumber;

//   return {
//     years: ageInSeconds / (24 * 3600 * 365.25 * 1000),
//     month:
//   }
//   return ageInSeconds / (24 * 3600 * 365.25 * 1000);
// };
// }

export const  calculateFloorAge=(dateStr: string): number =>{
  const dateParts = dateStr.split('-');
  const birthDate = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
  const currentDate = new Date();
  const ageInMilliseconds = currentDate.getTime() - birthDate.getTime();
  const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365);
  return Math.floor(ageInYears);
}

export const getMaxDob = (dateInputs: string[]): string => {
  let maxAge = -Infinity;
  let maxAgeDOB = '';
  for (const dateStr of dateInputs) {
    const age = calculateFloorAge(dateStr);
    if (age > maxAge) {
      maxAge = age;
      maxAgeDOB = dateStr;
    }
  }
  return maxAgeDOB;
}


export const dateFormatter = (date:string) => {
  // var formattedDate = new Date(date);
   // M-D-YYYY
  let formattedDate = date.split('-')

  try {
    let day = parseInt(formattedDate[2])
    let month = parseInt(formattedDate[1])
    let year = parseInt(formattedDate[0])
    
  
    let dateString = year + '-' + (month <= 9 ? '0' + month : month) + '-' + (day <= 9 ? '0' + day : day);
    
    return dateString
  } catch (error) {
    return ''
    
  }
  
}
export const openLinkInSpecifiedTab = (
  link: string,
  target: '_blank' | '_self' | '_parent' | '_top' | 'framename'
) => {
  const aTag: HTMLAnchorElement = document.createElement('a');
  aTag.href = link;
  aTag.target = target;
  aTag.click();
};